export const INDIVIDU_CATEGORIES = [
  "Siswa SD", "Siswa SMP", "Siswa SMA", "Mahasiswa", "Karyawan", "Orang tua siswa",
];
export const LEMBAGA_CATEGORIES = [
  "Sekolah", "Kepala Sekolah", "Yayasan Pendidikan", "Lembaga Pendidikan", "Lembaga Sosial",
  "Corporate", "HRD BUMN", "HRD BUMD", "HRD Perusahaan Swasta", "Instansi Pemerintah",
];
export const SOURCES = [
  "WhatsApp", "Website", "Chatbot Website", "Instagram", "Facebook", "TikTok", "Google",
  "Spanduk", "Brosur", "Referensi", "Sekolah", "Alumni", "Lainnya",
];
export const MODES = ["Offline", "Online", "Hybrid"];
export const CHANNELS = ["WhatsApp", "Telepon", "Email", "Pertemuan", "Lainnya"];
export const FU_STATUS = ["terjadwal", "selesai", "terlambat", "dibatalkan"];
export const FU_STATUS_LABELS = {
  terjadwal: "Terjadwal", selesai: "Selesai", terlambat: "Terlambat", dibatalkan: "Dibatalkan",
};
export const STATUS_LABELS = { prospek_baru: "Prospek Baru" };

export const PIPELINE_STATUSES = [
  "prospek_baru", "sudah_dihubungi", "tertarik", "trial", "negosiasi",
  "menunggu_keputusan", "berhasil", "tidak_berhasil",
];
export const PIPELINE_STATUS_LABELS = {
  prospek_baru: "Prospek Baru",
  sudah_dihubungi: "Sudah Dihubungi",
  tertarik: "Tertarik",
  trial: "Trial / Placement Test",
  negosiasi: "Negosiasi",
  menunggu_keputusan: "Menunggu Keputusan",
  berhasil: "Berhasil / Deal",
  tidak_berhasil: "Tidak Berhasil / Lost",
};
export const PIPELINE_STATUS_CLS = {
  prospek_baru: "bg-slate-100 text-slate-700 border-slate-200",
  sudah_dihubungi: "bg-blue-50 text-blue-700 border-blue-200",
  tertarik: "bg-indigo-50 text-indigo-700 border-indigo-200",
  trial: "bg-purple-50 text-purple-700 border-purple-200",
  negosiasi: "bg-amber-50 text-amber-800 border-amber-200",
  menunggu_keputusan: "bg-orange-50 text-orange-700 border-orange-200",
  berhasil: "bg-green-50 text-green-700 border-green-200",
  tidak_berhasil: "bg-red-50 text-red-700 border-red-200",
};
export const LOST_REASONS = [
  "Biaya", "Jadwal tidak sesuai", "Lokasi", "Memilih lembaga lain",
  "Tidak dapat dihubungi", "Belum berminat", "Lainnya",
];
export function statusLabel(s) {
  return PIPELINE_STATUS_LABELS[s] || "Prospek Baru";
}

export const STUDENT_STATUS = ["calon_terdaftar", "aktif", "nonaktif"];
export const STUDENT_STATUS_LABELS = {
  calon_terdaftar: "Calon Siswa Terdaftar", aktif: "Aktif", nonaktif: "Nonaktif",
};
export const CLIENT_STATUS = ["persiapan", "aktif", "nonaktif"];
export const CLIENT_STATUS_LABELS = {
  persiapan: "Persiapan", aktif: "Aktif", nonaktif: "Nonaktif",
};
export const ENTITY_STATUS_CLS = {
  calon_terdaftar: "bg-blue-50 text-blue-700 border-blue-200",
  persiapan: "bg-amber-50 text-amber-800 border-amber-200",
  aktif: "bg-green-50 text-green-700 border-green-200",
  nonaktif: "bg-slate-100 text-slate-500 border-slate-200",
};

export function categoriesFor(type) {
  return type === "lembaga" ? LEMBAGA_CATEGORIES : INDIVIDU_CATEGORIES;
}

export function waLink(phoneNormalized) {
  const digits = (phoneNormalized || "").replace(/[^0-9]/g, "");
  return digits ? `https://wa.me/${digits}` : "#";
}

// Treat a datetime-local value as WIB (UTC+7) and return UTC ISO for storage.
export function wibLocalToUtcIso(localVal) {
  if (!localVal) return "";
  try {
    return new Date(localVal + ":00+07:00").toISOString();
  } catch {
    return "";
  }
}
